import { render, staticRenderFns } from "./SettingsEvents.vue?vue&type=template&id=32aca166&"
import script from "./SettingsEvents.vue?vue&type=script&lang=js&"
export * from "./SettingsEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports